import React from "react";
import { AppReleaseCenterTemplate } from "themes/administration/app-release/pages";
import { AppReleaseCenterViewStore } from "administration/app-release/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new AppReleaseCenterViewStore(rootStore, componentProps),
    "appReleaseCenterViewStore"
)
class EmbeddedAppRelease extends React.Component {
    render() {
        return <AppReleaseCenterTemplate {...this.props} />;
    }
}

export default EmbeddedAppRelease;
